import React from 'react';
import PropTypes from 'prop-types';
import { notifyInfo } from '../../utils/notifier';
import {
  fetchCompany,
  updateCompany,
  uploadLogo,
  deleteLogo
} from '../../actions/companies/apiRequests';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import withEulaRestrictions from '../license/withEulaRestrictions';
import Page from '../shared/Page';
import Loader from '../shared/Loader';
import CompanyDetailsPage from './CompanyDetailsPage';
import { SPRUCE_ADMINS } from '../../constants/userRoles';


export class EditCompanyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: null
    };
    this.onSave = this.onSave.bind(this);
  }

  static get propTypes() {
    return {
      match: PropTypes.object,
      title: PropTypes.string,
      location: PropTypes.object
    }
  }

  get companyId() {
    const { params:urlParams={} } = this.props.match;
    return urlParams.id;
  }

  componentDidMount() {
    const { location={} } = this.props;
    const { state:locationState={} } = location;
    fetchCompany(this.companyId)
      .then(company => this.setState({ company }))
      .then(() => {
        if (locationState.created) {
          notifyInfo('Company was created');
        }
      });
  }

  updateCompany(company) {
    return updateCompany(this.companyId, {
      ...company
    });
  }

  uploadLogo({ id }, file=null, deleted) {
    if (file) {
      return uploadLogo(id, file);
    }

    if (deleted) {
      return deleteLogo(id);
    }

    return Promise.resolve();
  }

  onSave(company, logo, logoDeleted) {
    return this.updateCompany(company)
      .then(() => this.uploadLogo(company, logo, logoDeleted));
  }

  render() {
    const { title } = this.props;
    const { company } = this.state;

    return (
      <Choose>
        <When condition={!company}>
          <Page header={title}>
            <Loader />
          </Page>
        </When>
        <Otherwise>
          <CompanyDetailsPage
            company={company}
            editStatus={false}
            editIsn={true}
            onSave={this.onSave}
            {...this.props}
          />
        </Otherwise>
      </Choose>
    );
  }
}

export default withEulaRestrictions(withRoleRestrictions(EditCompanyPage, SPRUCE_ADMINS));



// WEBPACK FOOTER //
// src/components/companyDetails/EditCompanyPage.jsx